const es = {
  floorplan: 'Plano',
  fullscreen: 'Ver a pantalla completa',
  location: 'Ubicación',
  share: 'Compartir',
  name: 'Nombre',
  email: 'Correo electrónico',
  phone: 'Teléfono',
  visitorAgreement: 'Acepto las <a href="https://www.istaging.com/legal/terms_of_service" target="_blank">condiciones de uso</a> y la <a href="https://www.istaging.com/legal/privacy_policy" target="_blank">política de privacidad.',
  visitorLeaveDataReason: '¡Bienvenido a esta experiencia virtual! Una vez que envíes tus datos de contacto, recibirás un código de acceso por correo electrónico, para que puedas entrar.',
  visitorAgreePolicy: 'Acepto que el propietario de esta experiencia virtual se ponga en contacto conmigo por correo electrónico o por teléfono.',
  visitorEnterAccessKey: 'Ingresa el código de acceso que recibiste por correo electrónico. Si no lo has recibido, revisa tu carpeta de spam.',
  accessCode: 'código de acceso',
  accessCodeError: 'Error de código de acceso',
  verify: 'Verificar',
  back: 'Atrás',
  welcomeToLiveTour: 'Bienvenido a <strong>LiveTour</strong>',
  resend: 'Reenviar',
  GuidedTour: 'Visita Guiada',
  ClientWelcome: 'Bienvenido',
  ClientFormHint: 'Al hacer clic en "Llamar ahora", acepto los <a href="https://www.istaging.com/legal/terms_of_service" target="_blank" class="link-yellow">Términos de servicio</a>, la <a class="link-yellow" href="https://www.istaging.com/legal/privacy_policy" target="_blank">Política de privacidad</a> y el agente puede contactarme por teléfono',
  ClientFormWelcomeText: 'Completa la siguiente información y haz clic en "Llamar ahora". <br>Serás guiado en vivo por un agente. <br>Conecta tus auriculares y micrófono y asegúrate de tener una buena conexión de red para una mejor experiencia.',
  ClientWelcomeNameHint: 'Por favor ingresa tu nombre',
  ClientWelcomePhoneHint: 'Por favor ingresa tu teléfono',
  ClientWelcomeLanguage: 'Idioma',
  ClientWelcomeLanguageDesc: 'Seleccione el idioma del guía turístico.',
  ClientWelcomeLanguageHint: 'Por favor, seleccione un idioma',
  FieldRequired: '* obligatorio',
  ClientFormCallNow: 'Llamar ahora',
  RememberMe: 'Recordarme',
  Submit: 'Enviar',
  search: 'Buscar',
  searchResult: 'Resultado de búsqueda',
  relatedResult: 'Resultado relacionado',
  scaleUp: 'Agrandar',
  scaleDown: 'Encogimiento',
  viewIn3D: 'Ver en 3D',
  pilotTooltipTitle: 'Recordatorio, puede hacer clic aquí para ver más rutas guiadas. ',
  pilotTooltipConfirm: '¡Ya veo! Empecemos',
  pilotTooltipCancel: 'Omitir el recorrido',
  selectPilot: 'Seleccionar piloto',
  pilotoInfluencer: 'influenciador piloto',
  pilotChaptersTitle: 'Capítulos de ruta (elegir escuchar)',
  pilotReadMoreBtnLabel: 'Ver contenido completo',
  pilotSelfBrowsingModeMessageTitle: 'Entrar en el modo de auto-navegación',
  pilotSelfBrowsingModeMessageContent: 'Puede volver al modo de recorrido en cualquier momento haciendo clic en el botón de encendido.',
  pilotReplay: 'Repetir',
  pilotPrevious: 'Anterior',
  pilotNext: 'Siguiente',
  pilotPause: 'Pausa',
  pilotPlay: 'Reproducir',
  pilotTurnOnSelfBrowsingMode: 'Desactivar el modo de viaje',
  pilotTurnOffSelfBrowsingMode: 'Activar modo recorrido',
  otherFunctions: 'otras funciones',
  returnToFirstPanorama: 'Volver al primer panorama',
  cookieBannerContent: 'We use cookies to enhance your browsing experience, serve personalized ads or content. By forwarding of viewing the website, you consent to our use of cookies. Please check',
  cookieBannerContentLinkAfter: 'for detail.',
  cookieBannerPolicyLinkText: 'Privacy Statement',
  cookieBannerButtonText: 'Accept'
}

export default es
